module.exports = __webpack_public_path__ + "assets/images/14-6.jpg";